import './App.scss';
import Topbar from "./components/topbar/Topbar.jsx";
import Intro from "./components/intro/Intro.jsx";
import Testimonials from "./components/testimonials/Testimonials.jsx";
import Introvideo from "./components/introvideo/Introvideo.jsx";
import Experts from "./components/experts/Experts.jsx";
import Reasons from "./components/reasons/Reasons.jsx";
import Courses from "./components/courses/Courses.jsx";
import Roadmap from "./components/roadmap/Roadmap.jsx";
import Footer from "./components/footer/Footer.jsx";

function App() {
  return (
    <div className="App">
      <Topbar />
      <Intro />
      <Testimonials />
      <Introvideo />
      <Experts />
      <Reasons />
      <Courses />
      <Roadmap />
      <Footer />
    </div>
  );
}

export default App;
